import * as settlebank from "./settlebank";

export const hectoFinancial = {
    ...settlebank,
}